<mat-dialog-content>
    <div class="file-description">
      <h3>Descrição do Arquivo</h3>
      <div class="description-content">
        <p *ngIf="element.acessDescription && element.acessDescription.trim() !== ''; else noDescription">
          {{ element.acessDescription }}
        </p>
  
        <ng-template #noDescription>
          <p class="no-description">Nenhuma descrição disponível.</p>
        </ng-template>
      </div>
  
      <h3>Parceiros Inclusos:</h3>
      <div class="partner-content">
        <div class="partner-box">
          <ng-container *ngIf="element.partners && element.partners.length > 0; else noPartner">
            <ul>
              <li *ngFor="let partner of element.partners">
                {{ partner }}
              </li>
            </ul>
          </ng-container>
  
          <ng-template #noPartner>
            <p class="no-partner">Nenhum parceiro disponível.</p>
          </ng-template>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  